import { MEGABYTES } from '@roko/ui/constants/common'

export const FILE_UPLOADER = {
  fileUploader: {
    dropzone: {
      dragAndDrop: 'Drag & drop a file here',
      clickToBrowse: 'Or click to browse',
      dropFiles: 'Drop file here...',
      dropImages: 'Drop images here...',
      button: {
        title: 'Browse files',
      },
      messages: {
        acceptedFiles: 'File type not supported.',
        fileNameTooLong: 'File name too long.',
        maxFileSize: `File size is max {{maxSize}} ${MEGABYTES}.`,
        maxFileCount: 'Max upload count: {{maxFiles}}',
        singleFileOnly: 'One file at a time',
      },
    },
  },
}
